import api from './apiClient';

// --- PAYLOAD AND RESPONSE INTERFACES ---
export interface ResetStreamKeyPayload {
  password: string;
}

export interface ResetStreamKeyResponse {
  success: boolean;
  newStreamKeyPin: string;
}

export interface ResetPinPayload {
  password: string;
}

export interface VerifyPinPayload {
  pin: string;
}

export interface VerifyPinResponse {
  success: boolean;
}

export interface UpdatePinPayload {
  pin: string;
}

export interface UpdateProfilePayload {
    firstName?: string;
    lastName?: string;
	altPhone?: string; // <-- ADD THIS LINE
    city?: string;
    postalCode?: string;
    country?: string;
}

type ChannelRouteTarget = number | string | { id?: number | string; hashId?: string | null; channelHashId?: string | null };

const resolveChannelRouteId = (channel: ChannelRouteTarget) => {
  if (channel && typeof channel === 'object') {
    return String(channel.channelHashId || channel.hashId || channel.id || '');
  }
  return String(channel ?? '');
};

// --- SERVICE FUNCTIONS ---

export const updateProfile = async (payload: UpdateProfilePayload): Promise<void> => {
    await api.patch('/users/me', payload);
};

export const updatePin = async (payload: UpdatePinPayload): Promise<{success: boolean}> => {
    const { data } = await api.patch('/users/me/pin', payload);
    return data;
};

export const verifyPin = async (payload: VerifyPinPayload): Promise<VerifyPinResponse> => {
  const { data } = await api.post<VerifyPinResponse>('/users/verify-pin', payload);
  return data;
};

export const resetPin = async (payload: ResetPinPayload): Promise<{success: boolean}> => {
    const { data } = await api.post('/users/reset-pin', payload);
    return data;
};

// --- THIS IS THE CORRECTED FUNCTION ---
// It now accepts a `channelId` and constructs the correct, channel-specific URL.
export const resetStreamKeyPin = async (channel: ChannelRouteTarget, payload: ResetStreamKeyPayload): Promise<ResetStreamKeyResponse> => {
    const routeId = resolveChannelRouteId(channel);
    const { data } = await api.post<ResetStreamKeyResponse>(`/users/me/channels/${routeId}/reset-stream-key`, payload);
    return data;
};
